import { buildDefaultDataProperty } from '@bingads-webui-campaign-react/ui-generator';

export const buildSchema = options => ({
  separatorStyles: {
    marginBottom: 20,
  },
  assets: {
    type: 'panel',
    header: {
      title: _TL_('Assets'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onAssetsHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      assetGroupName: buildDefaultDataProperty({
        label: _TL_('Asset group name'),
        dynamicProps: props => props.assetGroupName,
      }),
      appName: buildDefaultDataProperty({
        label: options.appPlatformString,
        dynamicProps: props => props.appName,
      }),
      hd1: {
        type: 'horizontal-divider',
      },
      images: {
        type: 'images',
        dynamicProps: props => props.images,
      },
      hd2: {
        type: 'horizontal-divider',
        isRendered: options.flow !== 'WINDOWS',
      },
      videos: {
        type: 'videos',
        dynamicProps: props => props.videos,
        isRendered: options.flow !== 'WINDOWS',
      },
      hd3: {
        type: 'horizontal-divider',
      },
      headlines: {
        type: 'headlines',
        dynamicProps: props => props.headlines,
      },
      descriptions: {
        type: 'descriptions',
        dynamicProps: props => props.descriptions,
      },
    },
  },
  targeting: {
    type: 'panel',
    header: {
      title: _TL_('Targeting'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onTargetingHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      locationTargeting: {
        type: 'location-targeting',
        dynamicProps: props => props.locationTargeting,
      },
      languages: {
        type: 'languages',
        dynamicProps: props => props.languages,
      },
      audienceSignal: {
        type: 'audience-signal',
        dynamicProps: props => props.audienceSignal,
      },
    },
  },
  campaignSettings: {
    type: 'panel',
    header: {
      title: _TL_('Campaign Details'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onCampaignSettingsHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      campaignName: buildDefaultDataProperty({
        label: _TL_('Campaign name'),
        dynamicProps: props => props.campaignName,
      }),
      adScheduleCampaign: {
        type: 'ad-schedule',
        dynamicProps: props => props.adScheduleCampaign,
      },
      conversionGoals: {
        type: 'conversion-goals',
        dynamicProps: props => props.conversionGoals,
      },
    },
  },
  budget: {
    type: 'panel',
    header: {
      title: _TL_('Budget'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onBudgetSettingsHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      budget: {
        type: 'budget',
        dynamicProps: props => props.budget,
      },
      bidStrategy: {
        type: 'bid-strategy',
        dynamicProps: props => props.bidStrategy,
      },
      bidValue: {
        type: 'bid-value',
        dynamicProps: props => props.bidValue,
      },
    },
  },
});
